import qc from 'qc'
import { scripts } from '@ps/bridge/qc/scripts/index'
import Vue from 'vue'
export interface IDragonBoneScript {
  play?:()=>void,
  loop:boolean; // 是否循环
  delay:number; // 延迟ms
  speed:number; // 速度
  animationName?:string; // 播放的动画
  playOnAwake:boolean; // 自动播放
}

/**
 * ps.SKPlayer
 * @param node
 * @param addScriptIfScriptNotExist
 */
export const getScript = (node: qc.Node, addScriptIfScriptNotExist = true): IDragonBoneScript | undefined => {
  const config: IDragonBoneScript | undefined = node.getScript(scripts.dragonBone.name)
  if (config) {
    // 脚本上没有animationName属性，$set一下，方便后续响应式
    Vue.set(config, 'animationName', config.animationName)
    return config
  }
  if (addScriptIfScriptNotExist) {
    const config = node.addScript(scripts.dragonBone.name)
    Vue.set(config, 'animationName', config.animationName)
    return config
  }
  return config
}
